import { render, staticRenderFns } from "./PunchLogSecurity.vue?vue&type=template&id=fcb23914&scoped=true&"
import script from "./PunchLogSecurity.vue?vue&type=script&lang=js&"
export * from "./PunchLogSecurity.vue?vue&type=script&lang=js&"
import style0 from "./PunchLogSecurity.vue?vue&type=style&index=0&id=fcb23914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb23914",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VPagination,VTextField})
